import emailjs from '@emailjs/browser';

// EmailJS configuration
const SERVICE_ID = 'service_kw0sfgn';
const ORDER_TEMPLATE_ID = 'template_order'; // You'll need to create this template in EmailJS
const PUBLIC_KEY = 'EG7_eXs8aW13pETh7';

/**
 * Submit an order via EmailJS
 * @param {Object} orderData - Order information
 * @param {string} orderData.product - Product name
 * @param {string} orderData.size - Selected size
 * @param {string} orderData.email - Customer email
 * @param {string} orderData.phone - Customer phone
 * @param {string} orderData.address - Shipping address
 * @returns {Promise} EmailJS response
 */
export async function submitOrder(orderData) {
    try {
        const templateParams = {
            product_name: orderData.product,
            size: orderData.size,
            customer_email: orderData.email,
            customer_phone: orderData.phone,
            shipping_address: orderData.address,
            order_date: new Date().toLocaleString('es-ES')
        };

        const response = await emailjs.send(
            SERVICE_ID,
            ORDER_TEMPLATE_ID,
            templateParams,
            PUBLIC_KEY
        );

        return response;
    } catch (error) {
        console.error('Error submitting order:', error);
        throw error;
    }
}

/**
 * Update stock in Google Sheets (via webhook)
 * Note: This requires a Google Apps Script webhook to be set up
 * Follow the instructions in GOOGLE_SHEETS_SETUP.md to configure this
 * @param {string} product - Product name
 * @param {string} size - Size to decrement
 */
export async function updateStock(product, size) {
    // TODO: Replace this with your actual Google Apps Script webhook URL
    // Follow the setup guide in GOOGLE_SHEETS_SETUP.md
    const WEBHOOK_URL = process.env.REACT_APP_STOCK_WEBHOOK_URL || '';

    if (!WEBHOOK_URL) {
        console.log(`Stock update needed: ${product} - Size ${size}`);
        console.warn('Stock webhook URL not configured. See GOOGLE_SHEETS_SETUP.md');
        return;
    }

    try {
        // Normalize product name to match sheet format (handle accents)
        const normalizedProduct = product.replace('í', 'i').replace('á', 'a');

        await fetch(WEBHOOK_URL, {
            method: 'POST',
            mode: 'no-cors', // Required for Google Apps Script
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                product: normalizedProduct,
                size
            })
        });

        console.log(`Stock update requested: ${product} - Size ${size}`);
    } catch (error) {
        console.error('Error updating stock:', error);
    }
}
